import messages from './messages.js'

const rules = {
	firmNameRule: [v => !!v || messages.FIRM_NAME_ERROR],
	mobileRule: [
		// v=>!!v || messages.MOBILE_NUMBER_ERROR,
		v => {
			if (!isNaN(parseFloat(v)) && v >= 5000000000 && v <= 999999999999) return true;
			return messages.INVALID_MOBILE_NUMBER_ERROR;
		}
	],
	phoneRule: [
		// v=>!!v || messages.PHONE_NUMBER_ERROR,
		v => {
			if (!isNaN(parseFloat(v)) && v >= 5000000000 && v <= 999999999999) return true;
			return messages.INVALID_PHONE_NUMBER_ERROR;
		}
	],
	emailRule: [
		v => !!v || messages.EMAIL_ERROR,
		v => /.+@.+\..+/.test(v) || messages.EMAIL_MUST_BE_VALID,
	],
	passwordRule: [v => !!v || messages.PASSWORD_ERROR],
	confirmPasswordRule: [v => !!v || messages.CONFIRM_PASSWORD_ERROR],
	shopNumberRule: [v => !!v || messages.CONFIRM_PASSWORD_ERROR],
	pinCodeRule: [v => !!v || messages.PIN_CODE_ERROR],
	fullAddressRule: [v => !!v || messages.FULL_ADDRESS_ERROR],
	cityRule: [v => !!v || messages.CITY_ERROR],
	stateRule: [v => !!v || messages.STATE_ERROR],
	landlineNumberRule: [
		v => !!v || messages.LANDLINE_NUMBER_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v))) return true;
			return messages.INVALID_LANDLINE_NUMBER_ERROR;
		}
	],
	gstNumberRule: [
		v => !!v || messages.GST_NUMBER_ERROR,
		v => {
			var regex = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;
			if (!regex.test(v)) {
				return messages.INVALID_GST_NUMBER_ERROR
			}
			return true
		}
	],

	/* reatiler error*/
	reatilerRule: [
		v => {
			if (!v)
				return messages.RETAILER_ERROR
			if (!v.retailer_id) {
				return messages.RETAILER_ERROR
			}
			return true
		}
	],

	/* wholesaler error*/
	wholesalerRule: [
		v => {
			if (!v)
				return messages.WHOLESALER_ERROR
			if (!v.wholesaler_id) {
				return messages.WHOLESALER_ERROR
			}
			return true
		}
	],
	/* wholesaler error*/
	PLAN: [
		v => {
			if (!v)
				return messages.PLAN_ERROR
			if (!v.id) {
				return messages.PLAN_ERROR
			}
			return true
		}
	],

	PickupAgentRule: [
		v => {
			if (!v)
				return messages.PLEASE_SELECT
			if (!v.id) {
				return messages.PLEASE_SELECT + " " + v.agent_type
			}
			return true
		}
	],


	/* challan number error*/
	challanNumberRule: [v => !!v || messages.CHALLAN_NUMBER_ERROR],
	/* Amount number error*/
	amountRule: [
		v => !!v || messages.AMOUNT_ERROR,
		v => {
			if (!isNaN(parseFloat(v)) && v >= 1 && v <= 9999999999999) return true;
			return messages.AMOUNT_MUST_BE_ERROR;
		}
	],

	dateRule: [v => !!v || ""],





	NAME: [v => !!v || messages.NAME_ERROR],

	/* raise issue rules */
	shipmetIdRule: [v => !!v || messages.SHIPMENT_ID_ERROR],
	categoryRule: [v => !!v || messages.CATEGORY_ERROR],
	descriptionRule: [v => !!v || messages.DESCRIPTION_ERROR],


	/* New product form*/
	PRODUCT_NAME: [v => !!v || messages.PRODUCT_NAME_ERROR],
	MANUFACTURER: [v => !!v || messages.MANUFACTURER_ERROR],
	FARMULA: [v => !!v || messages.FARMULA_ERROR],
	OFFER: [
		v => {
			if (!v)
				return true
			if (!isNaN(parseFloat(v)) && v >= 0 && v <= 99) return true;
			return messages.OFFER_ERROR;
		}
	],


	/*ADHAAR NUMBER*/
	AADHAAR_NUMBER: [
		v => !!v || messages.AADHAAR_NUMBER_ERROR,
		// v  => {
		// 	var regex = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;    
		// 	if(!regex.test(v)){    
		// 		return messages.INVALID_AADHAAR_NUMBER_ERROR
		// 	}  
		// 	return true
		// } 
	],

	DL_NUMBER: [
		v => !!v || messages.DL_ERROR,
		// v  => {
		// 	var regex = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;    
		// 	if(!regex.test(v)){    
		// 		return messages.INVALID_DL_ERROR
		// 	}  
		// 	return true
		// } 
	],
	PAN_CARD: [
		v => !!v || messages.PAN_ERROR,
		// v  => {
		// 	var regex = /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/;    
		// 	if(!regex.test(v)){    
		// 		return messages.INVALID_PAN
		// 	}  
		// 	return true
		// } 
	],
	BANK_NAME: [v => !!v || messages.BANK_NAME_ERROR],
	ACCOUNT_HOLDER_NAME: [v => !!v || messages.ACCOUNT_HOLDER_NAME_ERROR],
	ACCOUNT_NUMBER: [
		v => !!v || messages.ACCOUNT_NUMBER_ERROR,
		v => {
			if (!isNaN(parseFloat(v))) return true;
			return messages.INVALID_ACCOUNT_NUMBER_ERROR;
		}

	],
	IFSC: [v => !!v || messages.IFSC_ERROR],

	CREDIT_LIMIT: [
		v => !!v || messages.CREDIT_LIMIT_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v >= 1) return true;
			return messages.INVALID_CREDIT_LIMIT;
		}
	],

	GST: [
		v => !!v || messages.GST_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v >= 1) return true;
			return messages.GST_INVALID;
		}
	],
	PRICE: [
		v => !!v || messages.PRICE_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999999999999) return true;
			return messages.PRICE_INVALID;
		}
	],
	MRP: [
		v => !!v || messages.MRP_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999999999999) return true;
			return messages.MRP_INVALID;
		}
	],
	DAYS: [
		v => !!v || messages.DAYS_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v >= 1) return true;
			return messages.DAYS_INVALID;
		}
	],
	DL_EXPIRY: [
		v => !!v || messages.DL_EXPIRY_ERROR],

	RECIPIENT_NAME: [v => !!v || messages.RECIPIENT_NAME_ERROR],
	AREA: [v => !!v || messages.AREA_ERROR],

	WAREHOUSE_NAME: [v => !!v || messages.WAREHOUSE_NAME_ERROR],
	WAREHOUSE: [v => !!v || messages.WAREHOUSE_ERROR],
	LINE: [v => !!v || messages.LINE_ERROR],
	LINE_NAME: [v => !!v || messages.LINE_NAME_ERROR],
	LINE_ID: [v => !!v || messages.LINE_ID_ERROR],
	DELIVERY_TIME: [v => !!v || messages.DELIVERY_TIME_ERROR],
	NO_OF_SHIPMENT_ALLOWED: [
		v => !!v || messages.SHIPMENT_COUNT_ERROR,
		v => {
			if (!isNaN(parseFloat(v)) && v >= 0 && v <= 999999999999) return true;
			return messages.SHIPMENT_COUNT_ERROR;
		}
	],

	NUMBER: [
		v => !!v || messages.NUMBER_ERROR,
		v => {
			// if (!v.trim()) return true;
			if (!isNaN(parseFloat(v)) && v == 0 && v <= 99999) return true;
			return messages.NUMBER_INVALID;
		}
	],

	CHEQUE_NUMBER: [v => !!v || messages.CHEQUE_NUMBER_ERROR],
	NEFT_TRANSACTION_ID: [v => !!v || messages.NEFT_TRANSACTION_ID_ERROR],
	TYPE: [v => !!v || messages.TYPE_ERROR],

}


export default rules